import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.iterator.find.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/es.iterator.map.js";
import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, renderList as _renderList } from "vue";
const _hoisted_1 = {
  class: "wx-calendar-title"
};
const _hoisted_2 = {
  class: "wx-calendar-title-info"
};
const _hoisted_3 = {
  class: "wx-calendar-options"
};
const _hoisted_4 = {
  class: "wx-calendar-option"
};
const _hoisted_5 = {
  class: "wx-calendar-weeks"
};
const _hoisted_6 = ["data-wdx", "data-ddx"];
const _hoisted_7 = {
  class: "wx-calendar-panel-day"
};
const _hoisted_8 = {
  key: 1
};
const _hoisted_9 = {
  class: "wx-calendar-bar-control"
};
const _hoisted_10 = {
  class: "wx-calendar-bar-control-item"
};
const _hoisted_11 = {
  class: "wx-calendar-bar-control-item"
};
const _hoisted_12 = {
  class: "wx-calendar-years-bar"
};
const _hoisted_13 = {
  class: "wx-calendar-years-bar-lunar"
};
const _hoisted_14 = {
  class: "wx-calendar-years-container"
};
const _hoisted_15 = {
  class: "wx-calendar-years-months"
};
const _hoisted_16 = ["onClick"];
const _hoisted_17 = {
  class: "wx-calendar-years-month-container"
};
const _hoisted_18 = {
  class: "wx-calendar-years-month-title"
};
const _hoisted_19 = {
  class: "wx-calendar-years-month-content-item day"
};
const _hoisted_20 = {
  class: "wx-calendar-years-month-content-item"
};
import { computed, nextTick, onMounted, ref, watch } from "vue";
import { toLunar } from "./lunar";
const WEEKS_CN = "日一二三四五六";
const PANELS = 5;
const MIDDLE = 2;
export default /*@__PURE__*/_defineComponent({
  __name: 'index',
  props: {
    view: {
      default: "month"
    },
    value: {
      default: ""
    },
    markers: {
      default: () => []
    },
    showLunar: {
      type: Boolean,
      default: true
    },
    showMark: {
      type: Boolean,
      default: true
    },
    darkmode: {
      type: Boolean,
      default: false
    },
    checkedShow: {
      type: Boolean,
      default: true
    },
    startWeek: {
      default: 0
    }
  },
  emits: ["month-change", "date-change", "view-change", "load"],
  setup(__props, {
    expose: __expose,
    emit: __emit
  }) {
    const props = __props;
    const emit = __emit;
    // ==================== 基础工具 ====================
    const weekStart = computed(() => props.startWeek);
    const MonthDays = (y, m) => new Date(y, m, 0).getDate();
    const NormalDate = (year, month, day) => {
      const d = new Date(year, month - 1, day);
      return {
        year: d.getFullYear(),
        month: d.getMonth() + 1,
        day: d.getDate()
      };
    };
    const ResortWeeks = start => (WEEKS_CN.slice(start) + WEEKS_CN.slice(0, start)).split("");
    const WeekOrder = d => {
      const curr = new Date(d.year, d.month - 1, d.day);
      const first = new Date(d.year, 0, 1);
      const diff = Math.round((curr.valueOf() - first.valueOf()) / 86400000);
      return Math.ceil((diff + first.getDay()) / 7);
    };
    const DateDiff = (start, end) => Math.floor((new Date(end.year, end.month - 1, end.day).getTime() - new Date(start.year, start.month - 1, start.day).getTime()) / 86400000);
    const WeekFirstDay = (d, start) => {
      const _d = new Date(d.year, d.month - 1, d.day);
      const week = _d.getDay();
      const wf = new Date(_d.getFullYear(), _d.getMonth(), _d.getDate() - (week + 7 - start) % 7);
      return {
        year: wf.getFullYear(),
        month: wf.getMonth() + 1,
        day: wf.getDate()
      };
    };
    // 兼容小程序 wx-calendar 的多种入参格式
    const CorrectDate = (...args) => {
      if (args.length === 1) {
        const v = args[0];
        if (typeof v === "string") {
          const parts = v.split("-").map(s => parseInt(s, 10));
          if (parts.length < 3) {
            const d = new Date(v);
            if (isNaN(d.getTime())) return null;
            return {
              year: d.getFullYear(),
              month: d.getMonth() + 1,
              day: d.getDate()
            };
          }
          return NormalDate(parts[0], parts[1], parts[2]);
        }
        if (typeof v === "number") {
          const d = new Date(v);
          if (isNaN(d.getTime())) return null;
          return {
            year: d.getFullYear(),
            month: d.getMonth() + 1,
            day: d.getDate()
          };
        }
        if (Array.isArray(v)) {
          if (v.length < 3) return null;
          return NormalDate(Number(v[0]), Number(v[1]), Number(v[2]));
        }
        if (typeof v === "object" && v) {
          const {
            year,
            month,
            day
          } = v;
          if (!year || !month || !day) return null;
          return NormalDate(year, month, day);
        }
      }
      if (args.length === 3) {
        return NormalDate(parseInt(String(args[0]), 10), parseInt(String(args[1]), 10), parseInt(String(args[2]), 10));
      }
      return null;
    };
    // ==================== 布局计算（rpx -> 实际 px，等效 750 设计稿） ====================
    const getLayout = () => {
      const w = document.documentElement.clientWidth || 375;
      const scale = w / 750;
      return {
        mainH: Math.floor(820 * scale),
        panelH: Math.floor(620 * scale),
        minH: Math.floor(620 / 5 * scale) + Math.floor(200 * scale)
      };
    };
    const layout = getLayout();
    const mainH = ref(layout.mainH);
    const minH = ref(layout.minH);
    const panelHeight = ref(layout.panelH);
    // ==================== 状态 ====================
    const calendarEl = ref(null);
    const loaded = ref(false);
    const months = ref([]);
    const currTab = ref(MIDDLE);
    const currView = ref(props.view === "week" ? 2 : 1);
    const viewName = ref(props.view);
    const weeks = ref(ResortWeeks(weekStart.value));
    const titleInfo = ref("");
    const solidDay = ref(false);
    const barAnimation = ref(true);
    const yearPanelShow = ref(false);
    const heightAni = ref(false);
    const swiperTransition = ref(true);
    const dragDelta = ref(0);
    const dragRatio = ref(0);
    const calendarH = ref(layout.mainH);
    const markersMap = ref({});
    const weekRects = ref([]);
    const showLunar = computed(() => props.showLunar);
    const showMark = computed(() => props.showMark);
    const checkedShow = computed(() => props.checkedShow);
    const darkmode = computed(() => props.darkmode);
    let today;
    let selDay;
    let _currWeekIdx = 0;
    let lastEmitMonth = null;
    let swipeSettleTimer;
    const gesture = {
      active: false,
      mode: null,
      startX: 0,
      startY: 0,
      startH: 0
    };
    const tdOpShow = computed(() => {
      const m = months.value[currTab.value];
      return m ? !m.bar.t : false;
    });
    const swiperTransform = computed(() => {
      return `translateX(calc(${-currTab.value * 100}% + ${dragDelta.value}px))`;
    });
    // ==================== 日期服务（lunar / marker） ====================
    const buildMarkersMap = () => {
      const map = {};
      (props.markers || []).forEach(m => {
        if (!m || !["holiday", "corner", "schedule"].includes(m.type || "")) return;
        const key = `${m.year}_${m.month}_${m.day}`;
        if (!map[key]) map[key] = {
          holiday: [],
          corner: [],
          schedule: []
        };
        const item = {
          mark: m.type === "corner" ? (m.mark || "").substring(0, 2) : m.mark || "",
          color: m.color,
          bgColor: m.bgColor
        };
        map[key][m.type].push(item);
      });
      markersMap.value = map;
    };
    const date = o => {
      const _d = new Date(o.year, o.month - 1, o.day);
      const year = _d.getFullYear();
      const month = _d.getMonth() + 1;
      const day = _d.getDate();
      const week = _d.getDay();
      const lunar = showLunar.value && year >= 1901 && year <= 2100 ? toLunar(year, month, day) : null;
      const marker = showMark.value && markersMap.value[`${year}_${month}_${day}`] ? {
        ...markersMap.value[`${year}_${month}_${day}`]
      } : null;
      return {
        key: `d_${year}_${month}_${day}`,
        year,
        month,
        day,
        week,
        week_name: WEEKS_CN[week],
        today: !!(today && year === today.year && month === today.month && day === today.day),
        state: o.state,
        lunar,
        marker
      };
    };
    const monthList = (year, month) => Array.from({
      length: MonthDays(year, month)
    }, (_, i) => date({
      year,
      month,
      day: i + 1,
      state: ""
    }));
    const getMonthDays = d => {
      const monthDays = monthList(d.year, d.month);
      const first = monthDays[0];
      const last = monthDays[monthDays.length - 1];
      const beforeLength = Math.abs(first.week + 7 - weekStart.value) % 7;
      const before = [];
      for (let i = 0; i < beforeLength; i++) {
        before.push(date({
          year: first.year,
          month: first.month,
          day: -i,
          state: "prev"
        }));
      }
      before.reverse();
      const afterLength = 6 - Math.abs(last.week + 7 - weekStart.value) % 7;
      const after = [];
      for (let i = 0; i < afterLength; i++) {
        after.push(date({
          year: last.year,
          month: last.month,
          day: last.day + i + 1,
          state: "next"
        }));
      }
      return {
        count: monthDays.length,
        days: [...before, ...monthDays, ...after]
      };
    };
    const getMonthWeekDays = days => {
      const rows = [];
      for (let i = 0; i < days.length / 7; i++) {
        rows.push(days.slice(i * 7, i * 7 + 7));
      }
      return rows;
    };
    const calcMonthPanelTrans = (weekIdx, rows) => {
      const defaultH = panelHeight.value / 5;
      const currentH = rows === 5 ? defaultH : panelHeight.value / rows;
      const diff = rows === 5 ? 0 : (defaultH - currentH) / 2;
      return Math.floor((weekIdx * currentH - diff) * 10) / 10;
    };
    const getDayWeekIdxInMonth = (d, idays) => {
      const idx = idays.findIndex(x => x.month === d.month && x.day === d.day);
      return Math.floor(idx / 7);
    };
    const initMonth = d => {
      var _date$lunar;
      const normal = NormalDate(d.year, d.month, 1);
      const {
        days,
        count
      } = getMonthDays(normal);
      const xday = Math.min(d.day, count);
      const _date = days.find(x => x.year === normal.year && x.month === normal.month && x.day === xday) || days[0];
      const rows = getMonthWeekDays(days);
      const trans = calcMonthPanelTrans(getDayWeekIdxInMonth(_date, days), rows.length);
      return {
        key: `m_${normal.year}_${normal.month}`,
        year: normal.year,
        month: normal.month,
        count,
        idays: days,
        days: rows,
        bar: {
          i: 0,
          x: 0,
          y: "",
          t: false,
          d: 0,
          a: false,
          s: false
        },
        trans,
        transY: currView.value === 2 ? -trans : 0,
        wf: WeekFirstDay(_date, weekStart.value),
        lunar_year: showLunar.value ? (_date$lunar = _date.lunar) === null || _date$lunar === void 0 ? void 0 : _date$lunar.lunarYearCN : undefined
      };
    };
    const initWeekMonth = d => {
      var _date$lunar2;
      const normal = NormalDate(d.year, d.month, d.day);
      const {
        days,
        count
      } = getMonthDays(normal);
      const idx = days.findIndex(x => x.year === normal.year && x.month === normal.month && x.day === normal.day);
      const _date = days[Math.max(idx, 0)];
      const rows = getMonthWeekDays(days);
      const trans = calcMonthPanelTrans(getDayWeekIdxInMonth(_date, days), rows.length);
      return {
        key: `m_${normal.year}_${normal.month}`,
        year: normal.year,
        month: normal.month,
        count,
        idays: days,
        days: rows,
        bar: {
          i: 0,
          x: 0,
          y: "",
          t: false,
          d: 0,
          a: false,
          s: false
        },
        trans,
        transY: currView.value === 2 ? -trans : 0,
        wf: WeekFirstDay(_date, weekStart.value),
        lunar_year: showLunar.value ? (_date$lunar2 = _date.lunar) === null || _date$lunar2 === void 0 ? void 0 : _date$lunar2.lunarYearCN : undefined
      };
    };
    const rebuildMonths = (cy, cm) => {
      const list = [];
      for (let i = 0; i < PANELS; i++) {
        list.push(initMonth({
          year: cy,
          month: cm + (i - MIDDLE),
          day: selDay.day
        }));
      }
      months.value = list;
      currTab.value = MIDDLE;
    };
    const rebuildWeeks = d => {
      const list = [];
      for (let i = 0; i < PANELS; i++) {
        const nd = NormalDate(d.year, d.month, d.day + (i - MIDDLE) * 7);
        list.push(initWeekMonth(nd));
      }
      months.value = list;
      currTab.value = MIDDLE;
    };
    /** 面板位移与当前视图保持一致 */
    const syncTrans = () => {
      months.value.forEach(m => {
        m.transY = currView.value === 2 ? -m.trans : 0;
      });
    };
    // ==================== 选中逻辑 ====================
    const buildTitleInfo = d => {
      const orderWeek = `第${WeekOrder(d)}周`;
      if (d.year === today.year && d.month === today.month && d.day === today.day) {
        return currView.value === 2 ? `${orderWeek}  周${d.week_name}` : `周${d.week_name}`;
      }
      const diff = DateDiff(today, d);
      const prefix = currView.value === 2 ? `${orderWeek}  ` : "";
      return `${prefix}${Math.abs(diff)}天${diff < 0 ? "前" : "后"}`;
    };
    const initSelBar = i => {
      const r = weekRects.value[i % 7];
      const month = months.value[currTab.value];
      const wdx = Math.floor(i / 7);
      return {
        i,
        x: r ? r.center : 0,
        y: `${((wdx + 0.5) / month.days.length * 100).toFixed(2)}%`,
        t: selDay.today,
        d: selDay.day,
        a: true,
        s: true
      };
    };
    const setSelBar = () => {
      const month = months.value[currTab.value];
      if (!month) return;
      const day = Math.min(selDay.day, month.count);
      const findIdx = month.idays.findIndex(x => x.month === month.month && x.day === day);
      if (findIdx < 0) return;
      selDay = {
        ...month.idays[findIdx]
      };
      _currWeekIdx = getDayWeekIdxInMonth(selDay, month.idays);
      titleInfo.value = buildTitleInfo(selDay);
      month.bar = initSelBar(findIdx);
    };
    /** 周视图下选中圆条跟随同一星期位置 */
    const setSelBarForWeek = () => {
      const month = months.value[currTab.value];
      if (!month) return;
      const delta = (selDay.week + 7 - weekStart.value) % 7;
      const target = NormalDate(month.wf.year, month.wf.month, month.wf.day + delta);
      const findIdx = month.idays.findIndex(x => x.month === target.month && x.day === target.day);
      if (findIdx < 0) return setSelBar();
      selDay = {
        ...month.idays[findIdx]
      };
      _currWeekIdx = getDayWeekIdxInMonth(selDay, month.idays);
      titleInfo.value = buildTitleInfo(selDay);
      month.bar = initSelBar(findIdx);
    };
    const syncSelBar = () => {
      if (currView.value === 2) setSelBarForWeek();else setSelBar();
    };
    const setSelDate = idx => {
      const month = months.value[currTab.value];
      if (!month) return;
      selDay = {
        ...month.idays[idx]
      };
      const wdx = Math.floor(idx / 7);
      if (wdx !== _currWeekIdx) {
        months.value.forEach(m => {
          const xday = Math.min(selDay.day, m.count);
          m.trans = calcMonthPanelTrans(getDayWeekIdxInMonth({
            year: m.year,
            month: m.month,
            day: xday
          }, m.idays), m.days.length);
        });
      }
      _currWeekIdx = wdx;
      titleInfo.value = buildTitleInfo(selDay);
      month.bar = initSelBar(idx);
      syncTrans();
    };
    const onSelBarAniEnd = () => {
      const month = months.value[currTab.value];
      if (!month) return;
      month.bar.a = false;
    };
    const refreshCurrentWeekPanel = sel => {
      barAnimation.value = false;
      selDay = sel;
      months.value[currTab.value] = initWeekMonth({
        year: sel.year,
        month: sel.month,
        day: sel.day
      });
      syncSelBar();
      window.setTimeout(() => {
        barAnimation.value = true;
      }, 350);
    };
    const onDaySelect = (wdx, ddx) => {
      const month = months.value[currTab.value];
      if (!month || !loaded.value) return;
      const idx = wdx * 7 + ddx;
      const sel = month.idays[idx];
      if (sel.year === selDay.year && sel.month === selDay.month && sel.day === selDay.day) {
        return;
      }
      if (currView.value === 2) {
        if (sel.month !== month.month) refreshCurrentWeekPanel(sel);else setSelDate(idx);
        emitDateChange(sel);
      } else {
        if (sel.state === "prev" || sel.state === "next") {
          selDay = sel;
          rebuildMonths(sel.year, sel.month);
          syncSelBar();
          emitDateChange(sel);
          emitMonthChange();
        } else {
          setSelDate(idx);
          emitDateChange(sel);
        }
      }
    };
    const emitDateChange = d => {
      emit("date-change", {
        year: d.year,
        month: d.month,
        day: d.day
      });
    };
    const emitMonthChange = () => {
      const m = months.value[currTab.value];
      if (!m) return;
      if (lastEmitMonth && lastEmitMonth.year === m.year && lastEmitMonth.month === m.month) {
        return;
      }
      lastEmitMonth = {
        year: m.year,
        month: m.month
      };
      emit("month-change", {
        year: m.year,
        month: m.month
      });
    };
    // ==================== 视图切换（月/周） ====================
    const setView = view => {
      const target = view === "week" ? 2 : 1;
      const changed = currView.value !== target;
      currView.value = target;
      viewName.value = view;
      solidDay.value = target === 2;
      calendarH.value = target === 2 ? minH.value : mainH.value;
      syncTrans();
      syncSelBar();
      if (changed) emit("view-change", {
        view
      });
    };
    const toggleView = view => {
      heightAni.value = true;
      setView(view);
      window.setTimeout(() => {
        heightAni.value = false;
      }, 320);
    };
    const onViewToggle = () => {
      toggleView(viewName.value === "month" ? "week" : "month");
    };
    // ==================== 手势处理：横向滑动 + 纵向拖拽 ====================
    const calW = () => {
      var _calendarEl$value;
      return ((_calendarEl$value = calendarEl.value) === null || _calendarEl$value === void 0 ? void 0 : _calendarEl$value.clientWidth) || document.documentElement.clientWidth;
    };
    const onPointerDown = e => {
      if (!loaded.value) return;
      if (e.pointerType === "mouse" && e.button !== 0) return;
      gesture.active = true;
      gesture.mode = null;
      gesture.startX = e.clientX;
      gesture.startY = e.clientY;
      gesture.startH = calendarH.value;
      dragDelta.value = 0;
      try {
        e.currentTarget.setPointerCapture(e.pointerId);
      } catch (_) {
        /* noop */
      }
    };
    const onPointerMove = e => {
      if (!gesture.active) return;
      const dx = e.clientX - gesture.startX;
      const dy = e.clientY - gesture.startY;
      if (gesture.mode === null) {
        if (Math.abs(dx) > 8) gesture.mode = "x";else if (Math.abs(dy) > 8) gesture.mode = "y";else return;
      }
      if (gesture.mode === "x") {
        swiperTransition.value = false;
        dragDelta.value = dx;
        dragRatio.value = Math.max(-1, Math.min(1, dx / calW()));
      } else {
        heightAni.value = false;
        const h = Math.max(minH.value, Math.min(mainH.value, gesture.startH + dy));
        calendarH.value = h;
        const month = months.value[currTab.value];
        if (month) {
          const interp = month.trans * ((mainH.value - h) / (mainH.value - minH.value));
          month.transY = -interp;
        }
        dragRatio.value = (h - minH.value) / (mainH.value - minH.value);
      }
    };
    const onPointerUp = e => {
      if (!gesture.active) return;
      if (gesture.mode === "x") {
        dragDelta.value = 0;
        swiperTransition.value = true;
        const w = calW();
        const dir = gesture.startX - e.clientX > w * 0.25 ? 1 : e.clientX - gesture.startX > w * 0.25 ? -1 : 0;
        if (dir) {
          currTab.value = (currTab.value + dir + PANELS) % PANELS;
          if (swipeSettleTimer) window.clearTimeout(swipeSettleTimer);
          swipeSettleTimer = window.setTimeout(() => {
            applySwipeStep();
          }, 320);
        }
      } else if (gesture.mode === "y") {
        heightAni.value = true;
        const mid = minH.value + (mainH.value - minH.value) / 2;
        setView(calendarH.value >= mid ? "month" : "week");
        window.setTimeout(() => {
          heightAni.value = false;
        }, 300);
      } else {
        var _el$closest;
        // 轻点选中日期
        const el = document.elementFromPoint(e.clientX, e.clientY);
        const cell = el === null || el === void 0 || (_el$closest = el.closest) === null || _el$closest === void 0 ? void 0 : _el$closest.call(el, ".wx-calendar-panel-date");
        if (cell) {
          const wdx = Number(cell.dataset.wdx);
          const ddx = Number(cell.dataset.ddx);
          if (!isNaN(wdx) && !isNaN(ddx)) onDaySelect(wdx, ddx);
        }
      }
      gesture.active = false;
      gesture.mode = null;
      dragRatio.value = 0;
    };
    /** 滑动结束后的面板重建：居中到新月份/新一周 */
    const applySwipeStep = () => {
      swiperTransition.value = false;
      const c = months.value[currTab.value];
      if (currView.value === 2) {
        rebuildWeeks(c.wf);
      } else {
        rebuildMonths(c.year, c.month);
      }
      syncSelBar();
      emitMonthChange();
    };
    const jumpStep = dir => {
      swiperTransition.value = false;
      const c = months.value[currTab.value];
      if (!c) return;
      if (currView.value === 2) {
        rebuildWeeks(NormalDate(c.wf.year, c.wf.month, c.wf.day + dir * 7));
      } else {
        rebuildMonths(c.year, c.month + dir);
      }
      syncSelBar();
      emitMonthChange();
    };
    // ==================== 今日 / 指定日期 ====================
    const toToday = () => {
      if (today.year === selDay.year && today.month === selDay.month && today.day === selDay.day) {
        return;
      }
      selDay = today;
      if (currView.value === 2) handleWeekToDate(today);else handleMonthToDate(today);
    };
    const handleMonthToDate = d => {
      const isIn = months.value.findIndex(m => m.year === d.year && m.month === d.month);
      if (isIn === currTab.value) {
        const month = months.value[currTab.value];
        const findIdx = month.idays.findIndex(x => x.month === month.month && x.day === d.day);
        if (findIdx >= 0) setSelDate(findIdx);
        emitDateChange(d);
      } else {
        selDay = d;
        rebuildMonths(d.year, d.month);
        syncSelBar();
        emitMonthChange();
        emitDateChange(d);
      }
    };
    const handleWeekToDate = d => {
      const t = new Date(d.year, d.month - 1, d.day).getTime();
      const isIn = months.value.findIndex(m => {
        const start = new Date(m.wf.year, m.wf.month - 1, m.wf.day).getTime();
        const end = new Date(m.wf.year, m.wf.month - 1, m.wf.day + 7).getTime();
        return start <= t && end > t;
      });
      if (isIn === currTab.value) {
        const month = months.value[currTab.value];
        if (d.month !== month.month) refreshCurrentWeekPanel(d);else {
          const findIdx = month.idays.findIndex(x => x.month === d.month && x.day === d.day);
          if (findIdx >= 0) setSelDate(findIdx);
        }
        emitDateChange(d);
      } else {
        selDay = d;
        rebuildWeeks(WeekFirstDay(d, weekStart.value));
        syncSelBar();
        emitMonthChange();
        emitDateChange(d);
      }
    };
    const calendarToDate = (...args) => {
      const parsed = CorrectDate(...args);
      if (!parsed) return;
      selDay = date({
        ...parsed,
        state: ""
      });
      if (currView.value === 2) handleWeekToDate(selDay);else handleMonthToDate(selDay);
    };
    const calendarToMonth = (year, month) => {
      const parsed = CorrectDate(year, month, 1);
      if (!parsed) return;
      selDay = date({
        ...parsed,
        state: ""
      });
      if (currView.value === 2) handleWeekToDate(selDay);else handleMonthToDate(selDay);
    };
    const getDateInfo = (...args) => {
      const parsed = CorrectDate(...args);
      return parsed ? date({
        ...parsed,
        state: ""
      }) : null;
    };
    // ==================== 年份面板 ====================
    const yearPanelData = computed(() => {
      var _months$value$currTab, _months$value$currTab2, _toLunar$lunarYearCN, _toLunar;
      const year = (_months$value$currTab = (_months$value$currTab2 = months.value[currTab.value]) === null || _months$value$currTab2 === void 0 ? void 0 : _months$value$currTab2.year) !== null && _months$value$currTab !== void 0 ? _months$value$currTab : selDay ? selDay.year : new Date().getFullYear();
      const monthsArr = [];
      for (let m = 1; m <= 12; m++) {
        const cells = monthList(year, m);
        const lunarStarts = cells.map(c => c.lunar && c.lunar.lunarDay === 1 ? {
          day: c.day,
          lunar: c.lunar.lunarMonthCN
        } : null).filter(x => x !== null).slice(0, 3);
        monthsArr.push({
          month: m,
          curr: !!(today && today.year === year && today.month === m),
          lunar: lunarStarts
        });
      }
      return {
        year,
        lunarYear: (_toLunar$lunarYearCN = (_toLunar = toLunar(year, 6, 1)) === null || _toLunar === void 0 ? void 0 : _toLunar.lunarYearCN) !== null && _toLunar$lunarYearCN !== void 0 ? _toLunar$lunarYearCN : "",
        months: monthsArr
      };
    });
    const onTitleTap = () => {
      if (yearPanelShow.value) {
        yearPanelShow.value = false;
        return;
      }
      // 年份面板只在月视图（完整高度）下展示，周视图先切回月视图
      if (currView.value !== 1) {
        heightAni.value = true;
        setView("month");
        window.setTimeout(() => {
          heightAni.value = false;
        }, 300);
      }
      yearPanelShow.value = true;
    };
    const onYearMonthTap = (year, month) => {
      yearPanelShow.value = false;
      selDay = date({
        year,
        month,
        day: 1,
        state: ""
      });
      if (currView.value !== 1) setView("month");
      handleMonthToDate(selDay);
    };
    // ==================== 渲染辅助 ====================
    const panelMonthStyle = month => ({
      height: panelHeight.value + "px",
      minHeight: panelHeight.value + "px",
      transform: `translateY(${month.transY}px)`
    });
    const solarText = d => {
      if (!d.lunar) return "";
      if (d.lunar.lunarTerm) return d.lunar.lunarTerm;
      if (d.lunar.festival) return d.lunar.festival;
      if (d.lunar.lunarDayCN === "初一") return d.lunar.lunarMonthCN;
      return d.lunar.lunarDayCN;
    };
    const isSolarTerm = d => {
      var _d$lunar;
      return !!((_d$lunar = d.lunar) !== null && _d$lunar !== void 0 && _d$lunar.lunarTerm);
    };
    const cornerStyle = d => d.marker && d.marker.corner[0].color ? `color:${d.marker.corner[0].color};` : "";
    const holidayStyle = d => d.marker && d.marker.holiday[0].color ? `color:${d.marker.holiday[0].color};` : "";
    const refreshPanelDays = () => {
      if (!loaded.value) return;
      months.value.forEach((m, i) => {
        const {
          days
        } = getMonthDays({
          year: m.year,
          month: m.month
        });
        months.value[i].idays = days;
        months.value[i].days = getMonthWeekDays(days);
      });
    };
    // ==================== 周列位置（选中圆条 x 定位） ====================
    const calcWeekRects = () => {
      const el = calendarEl.value;
      if (!el) return;
      const calRect = el.getBoundingClientRect();
      const items = Array.from(el.querySelectorAll(".wx-calendar-weeks-item"));
      weekRects.value = items.map(item => {
        const r = item.getBoundingClientRect();
        return {
          center: r.left + r.width / 2 - calRect.left
        };
      });
    };
    const reloadPos = () => {
      calcWeekRects();
      syncSelBar();
      return Promise.resolve();
    };
    // ==================== 对外 API ====================
    const prev = () => jumpStep(-1);
    const next = () => jumpStep(1);
    // ==================== 初始化与监听 ====================
    const initData = () => {
      const now = new Date();
      today = date({
        year: now.getFullYear(),
        month: now.getMonth() + 1,
        day: now.getDate(),
        state: ""
      });
      const init = CorrectDate(props.value) || {
        year: today.year,
        month: today.month,
        day: today.day
      };
      selDay = date({
        ...init,
        state: ""
      });
    };
    // 在 setup 阶段即初始化 today/selDay（早于首次渲染与 onMounted），
    // 避免组件树首次求值时读到 undefined
    initData();
    onMounted(async () => {
      buildMarkersMap();
      calendarH.value = mainH.value;
      weeks.value = ResortWeeks(weekStart.value);
      await nextTick();
      calcWeekRects();
      if (props.view === "week") {
        rebuildWeeks(WeekFirstDay(selDay, weekStart.value));
        setView("week");
      } else {
        rebuildMonths(selDay.year, selDay.month);
      }
      syncSelBar();
      loaded.value = true;
      emit("load", {
        date: selDay,
        view: viewName.value,
        visualMonth: {
          year: months.value[currTab.value].year,
          month: months.value[currTab.value].month
        }
      });
      emitMonthChange();
    });
    watch(() => props.value, v => {
      if (v && loaded.value) {
        swiperTransition.value = false;
        const parsed = CorrectDate(v);
        if (parsed) {
          selDay = date({
            ...parsed,
            state: ""
          });
          if (currView.value === 2) {
            rebuildWeeks(WeekFirstDay(selDay, weekStart.value));
          } else {
            rebuildMonths(selDay.year, selDay.month);
          }
          syncSelBar();
          swiperTransition.value = true;
          emitMonthChange();
        }
      }
    });
    watch(() => props.markers, () => {
      buildMarkersMap();
      refreshPanelDays();
    }, {
      deep: true
    });
    __expose({
      getDateInfo,
      toDate: calendarToDate,
      toMonth: calendarToMonth,
      toggleView,
      prev,
      next,
      reloadPos
    });
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", {
        class: _normalizeClass(["wx-calendar-container", {
          darkmode: darkmode.value,
          'sel-hidden': !checkedShow.value
        }])
      }, [_createElementVNode("div", {
        ref_key: "calendarEl",
        ref: calendarEl,
        class: _normalizeClass(["wx-calendar", {
          load: loaded.value,
          ani: heightAni.value
        }]),
        style: _normalizeStyle({
          height: calendarH.value + 'px'
        })
      }, [_createElementVNode("div", _hoisted_1, [_createElementVNode("div", {
        class: "wx-calendar-title-main",
        onClick: onTitleTap
      }, [months.value[currTab.value] ? (_openBlock(), _createElementBlock(_Fragment, {
        key: 0
      }, [_createElementVNode("span", null, _toDisplayString(months.value[currTab.value].year), 1), _cache[0] || (_cache[0] = _createElementVNode("span", {
        class: "cn"
      }, "年", -1)), _createElementVNode("span", null, _toDisplayString(months.value[currTab.value].month), 1), _cache[1] || (_cache[1] = _createElementVNode("span", {
        class: "cn"
      }, "月", -1))], 64)) : _createCommentVNode("", true), _createElementVNode("span", _hoisted_2, _toDisplayString(titleInfo.value), 1)]), _createElementVNode("div", _hoisted_3, [_createElementVNode("div", {
        class: _normalizeClass(["wx-calendar-option", {
          show: tdOpShow.value
        }])
      }, [_createElementVNode("div", {
        class: "wx-calendar-option-views today",
        onClick: toToday
      }, _cache[2] || (_cache[2] = [_createElementVNode("div", {
        class: "wx-calendar-option-view"
      }, "今", -1)]))], 2), _createElementVNode("div", _hoisted_4, [_createElementVNode("div", {
        class: "wx-calendar-option-views",
        onClick: onViewToggle
      }, [_createElementVNode("div", {
        class: _normalizeClass(["wx-calendar-option-view", {
          curr: viewName.value === 'month'
        }])
      }, " 月 ", 2), _createElementVNode("div", {
        class: _normalizeClass(["wx-calendar-option-view", {
          curr: viewName.value === 'week'
        }])
      }, " 周 ", 2), _createElementVNode("div", {
        class: "wx-calendar-option-view-bar",
        style: _normalizeStyle({
          transform: viewName.value === 'week' ? 'translateX(35px) translateZ(0px)' : 'translateX(0px)'
        })
      }, null, 4)])])])]), _createElementVNode("div", _hoisted_5, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(weeks.value, w => {
        return _openBlock(), _createElementBlock("div", {
          key: w,
          class: "wx-calendar-weeks-item"
        }, _toDisplayString(w), 1);
      }), 128))]), _createElementVNode("div", {
        class: _normalizeClass(["wx-calendar-panel", {
          solid: solidDay.value
        }]),
        onPointerdown: onPointerDown,
        onPointermove: onPointerMove,
        onPointerup: onPointerUp,
        onPointercancel: onPointerUp
      }, [loaded.value ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: _normalizeClass(["wx-calendar-swiper", {
          'no-transition': !swiperTransition.value
        }]),
        style: _normalizeStyle({
          transform: swiperTransform.value
        })
      }, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(months.value, (month, mdx) => {
        return _openBlock(), _createElementBlock("div", {
          key: month.key,
          class: _normalizeClass(["wx-calendar-panel-month", {
            curr: currTab.value === mdx,
            other: currTab.value !== mdx
          }]),
          style: _normalizeStyle(panelMonthStyle(month))
        }, [month.bar.s && currTab.value === mdx && checkedShow.value ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: _normalizeClass(["wx-calendar-panel-sel", {
            'no-ani': !barAnimation.value,
            today: month.bar.t
          }]),
          style: _normalizeStyle({
            top: month.bar.y,
            left: month.bar.x + 'px'
          })
        }, [_createElementVNode("div", {
          class: _normalizeClass(["wx-calendar-panel-sel-bar", {
            animation: month.bar.a
          }]),
          onAnimationend: onSelBarAniEnd
        }, null, 34)], 6)) : _createCommentVNode("", true), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(month.days, (w, wdx) => {
          return _openBlock(), _createElementBlock("div", {
            key: 'w_' + month.key + '_' + wdx,
            class: _normalizeClass(["wx-calendar-panel-row", 'l-' + month.days.length])
          }, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(w, (d, ddx) => {
            return _openBlock(), _createElementBlock("div", {
              key: d.key,
              class: _normalizeClass(["wx-calendar-panel-date", [d.state, {
                today: d.today,
                curr: wdx * 7 + ddx === month.bar.i && currTab.value === mdx
              }]]),
              "data-wdx": wdx,
              "data-ddx": ddx
            }, [_createElementVNode("div", _hoisted_7, [_createElementVNode("span", null, _toDisplayString(d.day), 1), d.marker && d.marker.corner.length ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: "wx-calendar-panel-day-corner",
              style: _normalizeStyle(cornerStyle(d))
            }, _toDisplayString(d.marker.corner[0].mark), 5)) : _createCommentVNode("", true)]), _createElementVNode("div", {
              class: _normalizeClass(["wx-calendar-panel-solar", {
                solar: isSolarTerm(d)
              }])
            }, [d.marker && d.marker.holiday.length ? (_openBlock(), _createElementBlock("span", {
              key: 0,
              style: _normalizeStyle(holidayStyle(d))
            }, _toDisplayString(d.marker.holiday[0].mark), 5)) : showLunar.value && solarText(d) ? (_openBlock(), _createElementBlock("span", _hoisted_8, _toDisplayString(solarText(d)), 1)) : _createCommentVNode("", true)], 2)], 10, _hoisted_6);
          }), 128))], 2);
        }), 128))], 6);
      }), 128))], 6)) : _createCommentVNode("", true)], 34), _createElementVNode("div", {
        class: "wx-calendar-bar",
        onPointerdown: onPointerDown,
        onPointermove: onPointerMove,
        onPointerup: onPointerUp,
        onPointercancel: onPointerUp
      }, [_createElementVNode("div", _hoisted_9, [_createElementVNode("div", _hoisted_10, [_createElementVNode("div", {
        class: "wx-calendar-bar-control-item-bar",
        style: _normalizeStyle({
          transform: 'rotate(' + dragRatio.value * 20 + 'deg)'
        })
      }, null, 4)]), _createElementVNode("div", _hoisted_11, [_createElementVNode("div", {
        class: "wx-calendar-bar-control-item-bar",
        style: _normalizeStyle({
          transform: 'rotate(' + -dragRatio.value * 20 + 'deg)'
        })
      }, null, 4)])])], 32), _createElementVNode("div", {
        class: _normalizeClass(["wx-calendar-years", {
          show: yearPanelShow.value
        }])
      }, [_createElementVNode("div", _hoisted_12, [_createElementVNode("div", {
        class: "wx-calendar-years-bar-title",
        onClick: onTitleTap
      }, [_createElementVNode("span", null, _toDisplayString(yearPanelData.value.year), 1), _cache[3] || (_cache[3] = _createElementVNode("span", {
        class: "cn"
      }, "年", -1)), _createElementVNode("span", _hoisted_13, _toDisplayString(yearPanelData.value.lunarYear), 1)])]), _createElementVNode("div", _hoisted_14, [_createElementVNode("div", _hoisted_15, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(yearPanelData.value.months, m => {
        return _openBlock(), _createElementBlock("div", {
          key: m.month,
          class: _normalizeClass(["wx-calendar-years-month", {
            curr: m.curr
          }]),
          onClick: $event => onYearMonthTap(yearPanelData.value.year, m.month)
        }, [_createElementVNode("div", _hoisted_17, [_createElementVNode("div", _hoisted_18, _toDisplayString(m.month), 1), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(m.lunar, (l, li) => {
          return _openBlock(), _createElementBlock("div", {
            key: li,
            class: "wx-calendar-years-month-content"
          }, [_createElementVNode("div", _hoisted_19, _toDisplayString(l.day), 1), _createElementVNode("div", _hoisted_20, _toDisplayString(l.lunar), 1)]);
        }), 128))])], 10, _hoisted_16);
      }), 128))])])], 2)], 6)], 2);
    };
  }
});